import React, { Suspense } from "react";
import FeePageLoader from "../../components/fees/FeePageLoader";

const FeesRouteSuspense = ({ children }) => (
  <Suspense fallback={<FeePageLoader minHeight={240} />}>
    {children}
  </Suspense>
);

export default FeesRouteSuspense;
